import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getNotificationsService } from "redux/services/general_service";
import { useLanguage } from "../LanguageContext"; // Adjust the import path

const NotificationPopup = ({ notifications, onClose }) => {
  const dispatch = useDispatch();
  const { metaNotifications } = useSelector((state) => state.general);
  const { direction } = useLanguage(); // Get the current language direction
  const itemsPerPage = 10;
  const [currentPage, setCurrentPage] = useState(1);
  const totalPages = Math.ceil(metaNotifications?.total / itemsPerPage);
  const currentNotifications = notifications.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  const handlePageChange = (page) => {
    setCurrentPage(page);
    dispatch(getNotificationsService({ page: page }));
  };

  // Determine the position based on the language direction
  const positionClass = direction === "rtl" ? "left-0" : "right-0";

  return (
    <div
      className={`absolute ${positionClass} mt-2 w-80 bg-white rounded-lg shadow-xl border border-gray-200 z-50 overflow-hidden`}
    >
      {/* Header */}
      <div className="px-4 py-3 border-b border-gray-200 bg-gray-50 flex justify-between items-center">
        <h3 className="font-semibold text-gray-800">Notifications</h3>
        {notifications.length > 0 && (
          <span className="text-xs bg-green-500 text-white px-2 py-1 rounded-full">
            {notifications.length} New
          </span>
        )}
      </div>

      {/* Notification List */}
      <div className="max-h-64 overflow-y-auto">
        {currentNotifications.length === 0 ? (
          <div className="p-4 text-center text-gray-500">
            No notifications available
          </div>
        ) : (
          currentNotifications.map((notification) => (
            <div
              key={notification.id}
              className="p-4 border-b border-gray-100 hover:bg-gray-50 transition-colors"
            >
              <div className="flex items-start">
                <div className="flex-shrink-0 mt-1">
                  <div className="w-3 h-3 bg-green-500 rounded-full"></div>
                </div>
                <div className="ml-3 flex-1">
                  <p className="text-sm font-medium text-gray-900">
                    {notification.title}
                  </p>
                  <p className="mt-1 text-sm text-gray-500">
                    {notification.message}
                  </p>
                  <p className="mt-1 text-xs text-gray-400">
                    {new Date(notification.created_at).toLocaleTimeString()}
                  </p>
                </div>
              </div>
            </div>
          ))
        )}
      </div>

      {/* Footer */}
      {notifications.length > 0 && (
        <div className="px-4 py-2 bg-gray-50 border-t border-gray-200 flex justify-between items-center">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className={`px-3 py-1 text-sm rounded ${
              currentPage === 1
                ? "text-gray-400 cursor-not-allowed"
                : "text-green-600 hover:bg-gray-100"
            }`}
          >
            Previous
          </button>
          <span className="text-sm text-gray-600">
            Page {currentPage} of {totalPages}
          </span>
          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className={`px-3 py-1 text-sm rounded ${
              currentPage === totalPages
                ? "text-gray-400 cursor-not-allowed"
                : "text-green-600 hover:bg-gray-100"
            }`}
          >
            Next
          </button>
        </div>
      )}

      <button
        onClick={onClose}
        className="w-full py-2 bg-gray-100 hover:bg-gray-200 text-center text-gray-700 text-sm font-medium transition-colors"
      >
        Close
      </button>
    </div>
  );
};

export default NotificationPopup;
